import { useCMSContent } from "../../hooks/useCMSContent";
import * as Lucide from "lucide-react";

// Custom SVG icons (kept for backwards compat with existing color-picker set)
const MotorcycleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5" cy="17" r="3"/><circle cx="19" cy="17" r="3"/>
    <path d="M5 17H3V13L7 9H10L14 4H19V9L17 11H14"/><path d="M10 17L14 11"/>
  </svg>
);
const HelmetIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C6.48 2 2 6.48 2 12v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c0-5.52-4.48-10-10-10z"/>
    <path d="M6 12h12"/><path d="M12 2v10"/>
  </svg>
);
const WalletIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/>
    <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/>
  </svg>
);

const CUSTOM = { Motorcycle: MotorcycleIcon, Helmet: HelmetIcon, Wallet: WalletIcon };

export const ICON_SET = [
  "Lightbulb","Wind","Home","Baby","Dog","Package","Motorcycle","Helmet",
  "Wallet","AlertTriangle","Car","Sun","MapPin","Bell","Shield","Heart",
];

export const COLOR_SET = [
  "from-yellow-500 to-amber-500",
  "from-cyan-500 to-blue-500",
  "from-red-500 to-rose-500",
  "from-pink-500 to-rose-500",
  "from-amber-500 to-orange-500",
  "from-blue-500 to-indigo-500",
  "from-purple-500 to-violet-500",
  "from-green-500 to-emerald-500",
  "from-slate-500 to-slate-600",
  "from-orange-500 to-red-500",
  "from-blue-600 to-blue-700",
  "from-red-600 to-rose-600",
];

export function resolveIcon(name) {
  if (CUSTOM[name]) return CUSTOM[name];
  if (Lucide[name]) return Lucide[name];
  return Lucide.Circle;
}

const RealLifeCases = () => {
  const { data: cms } = useCMSContent("landing_json");
  const c = cms?.real_life || {
    title: "AvisoCar en la vida real",
    subtitle: "Casos reales donde AvisoCar te ayuda",
    cases: [],
  };

  return (
    <section className="bg-[#F8FAFC] py-20 md:py-28" data-testid="real-life-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 max-w-2xl">
          <h2
            className="mb-4 text-3xl font-extrabold tracking-tight text-[#0B2545] sm:text-4xl lg:text-5xl"
            data-testid="real-life-title"
          >
            {c.title}
          </h2>
          <p className="text-base text-slate-600 md:text-lg" data-testid="real-life-subtitle">{c.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {(c.cases || []).map((item, index) => {
            const Icon = resolveIcon(item.icon);
            return (
              <div
                key={index}
                className="group rounded-2xl border border-slate-200/80 bg-white p-5 transition-transform duration-300 hover:-translate-y-1 hover:border-[#1B84FF]/40"
                data-testid={`real-life-case-${index}`}
              >
                <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-[#EAF4FF]">
                  <Icon className="h-5 w-5 text-[#1B84FF]" />
                </span>
                <h4 className="text-sm font-semibold leading-snug text-[#0B2545]">{item.title}</h4>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RealLifeCases;
